// Importing the Search icon from the lucide-react library
import { Search } from 'lucide-react';

// Props interface to define the expected properties for the JobHero component
interface JobHeroProps {
  searchTerm: string; // Current value of the search input
  onSearchChange: (value: string) => void; // Callback to handle changes in the search input
}

// Functional component definition
export function JobHero({ searchTerm, onSearchChange }: JobHeroProps) {
  return (
    <div className="gradient-primary">
      {/* Container for the hero section */}
      <div className="container mx-auto px-4 py-16">
        {/* Title of the hero section */}
        <h1 className="section-title text-center mb-6 text-primary-lightest">
          Trouvez votre emploi dans le paysagisme
        </h1>
        
        {/* Subtitle providing additional context */}
        <p className="section-subtitle text-center mb-8 text-primary-lightest">
          Les meilleures opportunités pour votre carrière dans le jardinage et développement durable
        </p>

        {/* Search Input Section */}
        <div className="max-w-2xl mx-auto">
          <div className="relative">
            {/* Search Icon positioned inside the input field */}
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-light" />

            {/* Input field for searching jobs */}
            <input
              type="text" // Input type is text
              placeholder="Rechercher un poste, une entreprise..." // Placeholder text
              value={searchTerm} // Binds the input value to the searchTerm prop
              onChange={(e) => onSearchChange(e.target.value)} // Updates searchTerm on input change
              className="input-primary w-full pl-10 pr-4 py-3 text-gray-900 placeholder-gray-500 focus:outline-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
